<div class="waste-comments-list-wrapper fw fh">
    <div class="comment fw"
        *ngFor="let comment of commentsList">
        <div class="name-logo">
            <span>{{comment?.firstName?.charAt(0)}}</span>
            <span>{{comment?.lastName?.charAt(0)}}</span>
        </div>
        <div class="comment-body">
            <div class="title">
                <div class="user">
                    <span>{{comment?.firstName}}&nbsp;{{comment?.lastName}}</span>
                </div>
                <div class="time">
                    <span>
                        {{comment?.dateTime | date :  "dd"}}/{{comment?.dateTime | date :  "MMM" | translate}}/{{comment?.dateTime | date :  "yyyy, h:mm a"}}
                    </span>
                </div>
            </div>
            <div class="comment-dtls-wrapper">
                <div class="row-split">
                    <div class="split left what">
                        <div class="label">
                            <span>{{'5w1h.what' | translate}}</span>
                        </div>
                        <div class="details">
                            <span *ngIf="comment?.what">{{comment?.what}}</span>
                            <span *ngIf="!comment?.what">--</span>
                        </div>
                    </div>
                    <div class="split right where">
                        <div class="label">
                            <span>{{'5w1h.where' | translate}}</span>
                        </div>
                        <div class="details">
                            <span *ngIf="comment?.where">{{comment?.where}}</span>
                            <span *ngIf="!comment?.where">--</span>
                        </div>
                    </div>
                </div>
                <div class="row-split">
                    <div class="split left when-from">
                        <div class="label">
                            <span>{{'5w1h.when' | translate}} ({{'5w1h.whenFromDate' | translate}})</span>
                        </div>
                        <div class="details">
                            <span *ngIf="comment?.whenFromTime">
                                {{comment?.whenFromTime | date :  "dd"}}/{{comment?.whenFromTime | date :  "MMM" | translate}}/{{comment?.whenFromTime | date :  "yyyy, h:mm a"}}
                            </span>
                            <span *ngIf="!comment?.whenFromTime">--</span>
                        </div>
                    </div>

                    <div class="split right when-to">
                        <div class="label">
                            <span>{{'5w1h.when' | translate}} ({{'5w1h.whenToDate' | translate}})</span>
                        </div>
                        <div class="details">
                            <span *ngIf="comment?.whenToTime">
                                {{comment?.whenToTime | date :  "dd"}}/{{comment?.whenToTime | date :  "MMM" | translate}}/{{comment?.whenToTime | date :  "yyyy, h:mm a"}}
                            </span>
                            <span *ngIf="!comment?.whenToTime">--</span>
                        </div>
                    </div>
                </div>
                <div class="row-split">
                    <div class="split left why">
                        <div class="label">
                            <span>{{'5w1h.why' | translate}}</span>
                        </div>
                        <div class="details">
                            <span *ngIf="comment?.why">{{comment?.why}}</span>
                            <span *ngIf="!comment?.why">--</span>
                        </div>
                    </div>
                    <div class="split right how">
                        <div class="label">
                            <span>{{'5w1h.how' | translate}}</span>
                        </div>
                        <div class="details">
                            <span *ngIf="comment?.how">{{comment?.how}}</span>
                            <span *ngIf="!comment?.how">--</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="no-comments fh"
        *ngIf="!commentsList || commentsList?.length === 0">
        <span>{{'5w1h.no_comments' | translate}}</span>
    </div>
</div>